import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";

import {
  getSettingState,
  setLoadNavigation,
  setCategoryExplor,
} from "../../../../redux/features/settingSlice";
import TableCarts from "../../TableList/TableCarts/index";
import TableLoadingCart from "../../TableList/TableLoadingCart/index";
import EmptyExplore from "../EmptyExplore";
import { fetcherGetToken } from "../../../../services/fetcher";

const Table = ({ type }) => {
  const { categoryExplor, searchExplore } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const conditionalReq = () => {
    let mode = null;

    if (type === "home" || categoryExplor) {
      mode = `/content/tables/?${
        categoryExplor ? `&category=${categoryExplor.pk}` : ""
      }
      `;
    }
    if (type === "explore" && searchExplore) {
      mode = `/content/search/?query=${searchExplore}`;
    }

    return mode;
  };

  const {
    data: mainTable,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;

      return [
        `${process.env.REACT_APP_API + conditionalReq()}&page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,

    {
      revalidateFirstPage: false,
    }
  );

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const getNewPage = size + 1 <= mainTable[0]?.total_pages;
    if (getNewPage) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      setSize(mainTable[0].total_pages);
    }
  };

  const tableList = () => {
    let dataArr = [];
    if (mainTable) {
      // eslint-disable-next-line array-callback-return
      mainTable.map((e) => {
        dataArr.push(...e.results);
      });
    }
    return dataArr;
  };

  useEffect(() => {
    if (categoryExplor) {
      navigate(location.pathname + `?category=${categoryExplor.name}`);
    }
  }, [categoryExplor, location.pathname, navigate]);

  const backBtn = () => {
    window.onpopstate = function () {
      dispatch(setCategoryExplor(null));
    };
  };
  categoryExplor && backBtn();

  return (
    <Box sx={{ px: "16px", mt: "6px" }}>
      {(isLoading || !mainTable) &&
        Array(3)
          .fill("")
          .map((row, i) => {
            return <TableLoadingCart key={i} />;
          })}

      {!isLoading &&
        mainTable &&
        tableList().map((row) => {
          return <TableCarts key={row.pk} rowData={row} type={type} />;
        })}

      {!isLoading && tableList().length === 0 && <EmptyExplore />}

      {!isLoading && mainTable && (
        <Box ref={ref} sx={{ display: "flex", justifyContent: "center" }}></Box>
      )}
    </Box>
  );
};
export default Table;
